export default "__VITE_ASSET__D0Qq6T2u__"